import React, { useEffect, useReducer, useState } from 'react'
import { Container, Typography, Paper } from '@mui/material'
import { PickingFinished } from '../../components/Picking/Views/PickingFinished'
import { PickingNoProduct } from '../../components/Picking/Views/PickingNoProduct'
import { PickingNoRoute } from '../../components/Picking/Views/PickingNoRoute'
import { PickingProduct } from '../../components/Picking/Views/PickingProduct'
import { PickingProductDiff } from '../../components/Picking/Views/PickingProductDiff'
import { PickingMessage } from '../../components/Picking/Views/PickingMessage'
import { PickingRouteReview } from '../../components/Picking/Views/PickingRouteReview'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import {
  PickingReducer,
  reducerInitialState
} from '../../components/Picking/PickingReducer'
import { Loading } from '../../components/UI'
import {
  PickingRouteNextPositionDto,
  PickingRoute,
  PickingRouteDetails,
  PickingRouteMovementDto,
  PickingInputData,
  EmptyPickingRouteRequestDto,
  PickingMessageView
} from '../../interfaces/Picking/Picking'
import { EnumPickingStep } from '../../components/Picking/pickingConfig'
import { PickingService } from '../../redux/services/pickingService'
import { saveDataPickingRoute } from '../../utils/localStorage'
import { PickingStart } from '../../components/Picking/Views/PickingStart'
import { PickingRouteDetailsReviewType } from '../../enums/ePickingRouteDetailsReviewType'

import { PickingRouteContext } from '../../components/Picking/PickingRouteContext'
import { ModifyLPNStep } from '../../components/Picking/Views/PickingModifyLPN'
import { EnumFlow } from '../../interfaces/PickingValidate/InventoryIncident'
import { Modal } from '../../components/_EOS/Modal'
import { useModal } from '../../hooks/useModal'
import { AssignToteStep } from '../../components/Picking/Views/PickingAssignTote'
import { eTypePickingRoute } from '../../enums/eTypePickingRoute'
import { eTypePosition } from '../../enums/eTypePosition'
import { useUser } from '../../hooks/useUser'

interface PickingPageProps {}

let listSkippedProductsIn: number[] = []
let listPositionsNoStockIn: string[] = []

export const PickingPage: React.FC<PickingPageProps> = () => {
  const {
    userDataState: { userData },
    getUserData
  } = useUser()

  const {
    size,
    isOpen,
    title,
    openModal: openModalDialog,
    closeModal: closeModalDialog
  } = useModal('Aviso!')

  const {
    size: sizeModalRTV,
    isOpen: isOpenModalRTV,
    openModal: openModalRTV,
    closeModal: closeModalRTV
  } = useModal('Picking RTV')

  const {
    size: sizeModalRecall,
    isOpen: isOpenModalRecall,
    openModal: openModalRecall,
    closeModal: closeModalRecall
  } = useModal('Picking RTV')

  const pickingLocalStorageName: string = 'pickingRouteData'
  const pickingRouteLocalStorage = JSON.parse(
    localStorage.getItem(pickingLocalStorageName)!
  )

  const showError = (message: string): void => {
    console.error(message)
    setIsLoading(false)
    setMessageView({
      title: 'ERROR EN LA OPERACIÓN',
      message: message,
      nextStep: EnumPickingStep.BeginProcess
    })
    setStep(EnumPickingStep.ViewPickingMessage)
  }
  // si la configuración esta desactivada (false) se usa el picking por pieza. (true) trabaja normalmente historia WMSE-60
  // const [pickingByPieceSameSKU, setPickingByPieceSameSKU] = useState(false)
  const [requiredTote, setRequiredTote] = useState(false)

  const [configPositionScan, setConfigPositionScan] = useState(false)
  const [statePositionsScaned, setStatePositionsScaned] = useState<string[]>([])
  const [state, dispatch] = useReducer(PickingReducer, reducerInitialState)
  const [messageView, setMessageView] = useState<PickingMessageView>(
    new PickingMessageView()
  )
  const [pickingRoute, setPickingRoute] = useState<PickingRoute | undefined>(
    undefined
  )
  const [pickingRouteDetails, setPickingRouteDetails] = useState<
    PickingRouteDetails | undefined
  >(undefined)
  const [inputData, setInputData] = useState<PickingInputData>(
    new PickingInputData()
  )
  const [step, setStep] = useState<number>(EnumPickingStep.ComponentLoaded)
  const [previousStep, setPreviousStep] = useState<number>(0)
  const [pickingService] = useState<PickingService>(
    new PickingService(showError)
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const { openSnackbar, messageColor, messageStatus } = state
  const [messageDialogAlert, setMessageDialogAlert] = useState<string>('')
  const handlerOpenAndCloseDialogAlert = (
    showSeconds: number = 3,
    message: string = ''
  ) => {
    setMessageDialogAlert(message)
    openModalDialog()

    setTimeout(() => {
      closeModalDialog()
    }, showSeconds * 1000)
  }
  const [skipPacking, setSkipPacking] = useState(false)

  const showMessage = (
    title: string,
    message: string,
    nextStep: number
  ): void => {
    setIsLoading(false)
    const msgView: PickingMessageView = {
      title: title,
      message: message,
      nextStep: nextStep
    }
    setMessageView(msgView)
    setStep(EnumPickingStep.ViewPickingMessage)
  }

  useEffect(() => {
    if (step === EnumPickingStep.ComponentLoaded) {
      setStep(EnumPickingStep.FetchUser)
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.FetchUser) {
      if (!userData) {
        getUserData()
      } else {
        setStep(EnumPickingStep.BeginProcess)
      }
    }
  }, [step])

  useEffect(() => {
    if (userData) {
      setIsLoading(false)
      if (step === EnumPickingStep.FetchUser) {
        setStep(EnumPickingStep.BeginProcess)
      }
    } else {
      getUserData()
    }
  }, [userData])

  useEffect(() => {
    if (step === EnumPickingStep.BeginProcess) {
      setPickingRoute(undefined)
      setPickingRouteDetails(undefined)
      setStep(EnumPickingStep.FetchRoute)
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.FetchRoute) {
      async function fetchData() {
        const route = await pickingService.getUserRoute(userData?.userId || 0)
        setIsLoading(false)
        if (route) {
          setPickingRoute(route)
          setConfigPositionScan(route.scanPositionOnPicking)
          setRequiredTote(route.mandatoryLPNOnPicking)
          setSkipPacking(route.autoAssignPackingPosition)
          route.scanPositionOnPicking && setStatePositionsScaned([])
        }
        setStep(EnumPickingStep.ViewPickingStart)
      }
      fetchData()
    }
  }, [step])

  // Asigna la ruta de picking
  useEffect(() => {
    if (step === EnumPickingStep.GenerateRoute) {
      async function fetchData() {
        setPickingRoute(undefined)

        const typePicking = selectedTypePickingRoute

        const route = await pickingService.startUserPicking(
          userData?.userId || 0,
          typePicking,
          selectedZoneId
        )

        setIsLoading(false)
        setPickingRoute(route)
        if (route) {
          setConfigPositionScan(route.scanPositionOnPicking)
          setRequiredTote(route.mandatoryLPNOnPicking)
          setSkipPacking(route.autoAssignPackingPosition)
          setStep(EnumPickingStep.FetchProduct)
        } else {
          showMessage(
            'Sin ruta asignada',
            'El usuario no tiene asignada ruta de picking',
            EnumPickingStep.BeginProcess
          )
        }
      }
      fetchData()
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.FetchProduct) {
      async function fetchData() {
        if (!pickingRoute) {
          throw new Error('La ruta de picking no está definida.')
        }

        const getNextRoutePositionDto: PickingRouteNextPositionDto = {
          pickingRouteId: pickingRoute.pickingRouteId,
          userId: userData?.userId || 0,
          listSkippedProducts:
            pickingRouteLocalStorage !== null
              ? pickingRouteLocalStorage.listSkippedProducts
              : [],
          listPositionsNoStock:
            pickingRouteLocalStorage !== null
              ? pickingRouteLocalStorage.listPositionsNoStock
              : []
        }
        const routeDetails = await pickingService.getNextRoutePosition(
          getNextRoutePositionDto
        )
        setIsLoading(false)
        setPickingRouteDetails(routeDetails)
        if (routeDetails) {
          // La config por marca vive en pickingRoute (fija durante toda la ruta).
          // No se lee de routeDetails.resumen: cuando el backend responde
          // success:false para señalizar fin de ruta, resumen viene con los
          // defaults de Resumen() (todo en false), no con la config real.
          const currentRequiredTote = pickingRoute.mandatoryLPNOnPicking

          // Si la ruta es de tipo recall, nos saltamos el packing
          // esto implica que se vaciaran los productos en una posición
          // especifica para recall
          let auxSkipPacking = pickingRoute.autoAssignPackingPosition
          if (pickingRoute.typePickingRouteId === eTypePickingRoute.Recall) {
            auxSkipPacking = true
          }

          if (routeDetails.position) {
            // Valida si el Tote es obligatorio
            if (currentRequiredTote && !pickingRoute.lpn) {
              setStep(EnumPickingStep.AssignTote)
            } else {
              setStep(EnumPickingStep.ViewPickingProduct)
              setInputData({
                ...inputData,
                quantity: routeDetails.realQuantity
              })
            }
          } else {
            if (auxSkipPacking) {
              await getPositionZone(
                pickingRoute.zoneId,
                pickingRoute.typePickingRouteId
              )
            } else {
              setStep(EnumPickingStep.ViewPickingFinished)
            }
          }
        }
      }
      fetchData()
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.UpdateProduct) {
      async function fetchData() {
        if (
          !pickingRoute ||
          !pickingRouteDetails ||
          !pickingRouteDetails?.product ||
          !pickingRouteDetails?.position
        ) {
          throw new Error('Item de ruta de picking no definido.')
        }

        const pickingRouteMovementDto: PickingRouteMovementDto = {
          skuId: pickingRouteDetails.product.skuId,
          quantityPicked: inputData.quantity,
          pickingRouteId: pickingRoute.pickingRouteId,
          positionId: pickingRouteDetails.position.positionId,
          userId: userData?.userId || 0,
          batchId: pickingRouteDetails.product.batchId
        }
        const apiResponse = await pickingService.savePickingRouteMovement(
          pickingRouteMovementDto
        )
        setIsLoading(false)
        if (apiResponse.success) {
          setPickingRouteDetails(undefined)
          setStep(EnumPickingStep.FetchProduct)
        } else {
          showError(`'Error actualizando producto: ${apiResponse.message}'`)
        }
      }
      fetchData()
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.EmptyRoute) {
      async function fetchData() {
        if (!pickingRoute) {
          throw new Error('La ruta de picking no está definida.')
        }

        const emptyRouteDto: EmptyPickingRouteRequestDto = {
          pickingRouteId: pickingRoute.pickingRouteId,
          userId: userData?.userId || 0,
          positionName: inputData.positionName
        }
        const apiResponse =
          await pickingService.emptyPickingRoute(emptyRouteDto)
        setIsLoading(false)
        if (apiResponse.success) {
          localStorage.removeItem(pickingLocalStorageName)
          listSkippedProductsIn = []
          listPositionsNoStockIn = []
          setPickingRoute(undefined)
          configPositionScan && setStatePositionsScaned([])
          showMessage(
            `Operación de vaciado exitosa a posición ${emptyRouteDto.positionName}`,
            '',
            EnumPickingStep.BeginProcess
          )
        } else {
          showError(`'Error vaciando ruta de picking: ${apiResponse.message}'`)
        }
      }
      fetchData()
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.UpdateProductOutOfStock) {
      if (!pickingRouteDetails) {
        throw new Error('Item de ruta de picking no definido.')
      }

      setPickingRouteDetails(undefined)
      setStep(EnumPickingStep.FetchProduct)
    }
  }, [step])

  useEffect(() => {
    if (step === EnumPickingStep.UpdateProductSkip) {
      if (!pickingRouteDetails) {
        throw new Error('Item de ruta de picking no definido.')
      }

      setPickingRouteDetails(undefined)
      setStep(EnumPickingStep.FetchProduct)
    }
  }, [step])

  const handleSnackbar = (isOpen: boolean) => {
    dispatch({ type: 'SWITCH_SNACKBAR', payload: isOpen })
  }

  const [selectedTypePickingRoute, setTypePickingRoute] =
    useState<eTypePickingRoute>(eTypePickingRoute.Estandar)

  const [selectedZoneId, setSelectedZoneId] = useState<number>(0)

  const handleGenerateRoute = () => {
    if (selectedTypePickingRoute === eTypePickingRoute.Recall) {
      openModalRecall('sm')
    } else if (selectedTypePickingRoute === eTypePickingRoute.RTV) {
      openModalRTV('sm')
    } else {
      generatePickingRoute()
    }
  }

  const handleChangeTypePickingRoute = (type: eTypePickingRoute) => {
    setTypePickingRoute(type)
  }

  const handleRtvGenerateRoute = () => {
    closeModalRTV()
    generatePickingRoute()
  }

  const handleRecallGenerateRoute = () => {
    closeModalRecall()
    generatePickingRoute()
  }

  const generatePickingRoute = () => {
    setPickingRoute(undefined)
    setStep(EnumPickingStep.GenerateRoute)
    setIsLoading(true)
  }

  const handleNextPickingProduct = () => {
    setPickingRouteDetails(undefined)
    setStep(EnumPickingStep.FetchProduct)
    setIsLoading(true)
  }

  const handleBeginProcess = () => {
    setStep(EnumPickingStep.BeginProcess)
  }

  const handleProductPickUp = (inputData: PickingInputData) => {
    const qtyPendingPicking: number =
      pickingRouteDetails?.realQuantity! - pickingRouteDetails?.pickedQuantity!

    if (qtyPendingPicking !== inputData.quantity) {
      saveDataPickingRoute(
        pickingRoute?.pickingRouteId,
        listPositionsNoStockIn,
        listSkippedProductsIn,
        pickingLocalStorageName
      )
    }

    setInputData(inputData)
    setStep(EnumPickingStep.UpdateProduct)
    setIsLoading(true)
  }

  const handleProductNotFound = () => {
    setInputData(inputData)
    setStep(EnumPickingStep.ViewPickingProductDiff)
  }

  const handleProductOutOfStock = () => {
    setInputData(inputData)
    listPositionsNoStockIn.push(`${pickingRouteDetails?.id}`)

    if (pickingRouteDetails && pickingRouteDetails.product) {
      pickingService.registerPositionAlert(
        pickingRouteDetails?.position?.positionId!,
        pickingRouteDetails?.product?.skuId,
        userData?.userId || 0,
        EnumFlow.PICKING_ROUTE_WITHOUT_UNITS,
        pickingRouteDetails.realQuantity,
        `No se encontraron unidades, por usuario ${userData?.userAlias || ''}`,
        pickingRouteDetails?.product?.batchId
      )
    }

    saveDataPickingRoute(
      pickingRoute?.pickingRouteId,
      listPositionsNoStockIn,
      listSkippedProductsIn,
      pickingLocalStorageName
    )
    setStep(EnumPickingStep.UpdateProductOutOfStock)
    setIsLoading(true)
  }

  // maneja el saltar posicion
  const handleProductSkip = () => {
    listSkippedProductsIn.push(pickingRouteDetails?.position?.positionId || 0)

    if (pickingRouteDetails && pickingRouteDetails.product) {
      pickingService.registerPositionAlert(
        pickingRouteDetails?.position?.positionId!,
        pickingRouteDetails?.product?.skuId,
        userData?.userId || 0,
        EnumFlow.PICKING_ROUTE_SKIP_POSITION,
        pickingRouteDetails.realQuantity,
        `Se salta posición, por usuario ${userData?.userAlias}`,
        pickingRouteDetails?.product?.batchId
      )
    }

    saveDataPickingRoute(
      pickingRoute?.pickingRouteId,
      listPositionsNoStockIn,
      listSkippedProductsIn,
      pickingLocalStorageName
    )
    setStep(EnumPickingStep.UpdateProductSkip)
    setIsLoading(true)
  }

  const handleSetStateEmptying = async () => {
    if (skipPacking) {
      await getPositionZone(
        pickingRoute?.zoneId || 0,
        pickingRoute?.typePickingRouteId || eTypePickingRoute.Estandar
      )
    } else {
      setStep(EnumPickingStep.ViewPickingFinished)
    }
  }

  type PositionInfo = {
    positionName: string
  }

  const getPositionByType = async (
    zoneId: number,
    typePicking: eTypePickingRoute
  ): Promise<PositionInfo[]> => {
    switch (typePicking) {
      case eTypePickingRoute.RTV:
        return await pickingService.getPackingPositionByZone(
          zoneId,
          eTypePosition.CalidadCaja
        )
      case eTypePickingRoute.Estandar:
      case eTypePickingRoute.ExternalStorage:
        return await pickingService.getPackingPositionForRecallRoute(
          pickingRoute?.pickingRouteId || 0
        )
      case eTypePickingRoute.Recall:
        return await pickingService.getPackingPositionForRecallRoute(
          pickingRoute?.pickingRouteId || 0
        )
      default:
        throw new Error('Tipo de picking no reconocido')
    }
  }

  const getPositionZone = async (zoneId: number, typePicking: number) => {
    const positions = await getPositionByType(zoneId, typePicking)

    if (positions && positions.length > 0) {
      if (positions.length > 1) {
        showMessage(
          'Sólo puede haber una posicion de packing por zona',
          '',
          EnumPickingStep.BeginProcess
        )
      } else {
        const dto: PickingInputData = {
          sku: '',
          quantity: 0,
          positionName: positions[0].positionName
        }
        handleFinishRoute(dto)
      }
    } else {
      showMessage(
        'Posición de packing no definida',
        '',
        EnumPickingStep.BeginProcess
      )
    }
  }

  const handleFinishRoute = (inputData: PickingInputData) => {
    setInputData(inputData)
    setStep(EnumPickingStep.EmptyRoute)
    setIsLoading(true)
  }

  const handleErrorReturn = () => {
    setStep(EnumPickingStep.ViewPickingStart)
  }

  const handleDetailButton = () => {
    setPreviousStep(step)
    setStep(EnumPickingStep.ViewPickingRouteDetails)
  }

  const handleLPNButton = () => {
    setPreviousStep(step)
    setStep(EnumPickingStep.ModifyLPN)
  }

  return (
    <PickingRouteContext.Provider
      value={{ setPreviousStep, setStep, step, previousStep }}
    >
      <SnackBar
        open={openSnackbar}
        setOpen={handleSnackbar}
        message={messageStatus}
        status={messageColor}
      />

      {isLoading && <Loading />}

      <Container maxWidth='xl' disableGutters sx={{ pt: 0, mt: -2 }}>
        <Paper elevation={2} style={{ padding: '30px 4px' }}>
          {step === EnumPickingStep.ViewPickingStart && (
            <PickingStart
              pickingRoute={pickingRoute}
              handleFetchProduct={handleNextPickingProduct}
              handleGenerateRoute={handleGenerateRoute}
              onChangeTypePickingRoute={handleChangeTypePickingRoute}
              selectedPickingType={selectedTypePickingRoute}
              selectedZoneId={selectedZoneId}
              setSelectedZoneId={setSelectedZoneId}
            />
          )}
          {step === EnumPickingStep.AssignTote && pickingRoute && (
            <AssignToteStep
              nextStep={() => setStep(EnumPickingStep.ViewPickingProduct)}
              goBack={() => setStep(previousStep)}
              pickingRoute={pickingRoute}
              updatePickingRoute={setPickingRoute}
            />
          )}
          {step === EnumPickingStep.ViewPickingProduct && (
            <PickingProduct
              pickingRoute={pickingRoute}
              pickingRouteDetails={pickingRouteDetails}
              handlePickUp={handleProductPickUp}
              handleNotFound={handleProductNotFound}
              handleDetailButton={handleDetailButton}
              handleLPNButton={handleLPNButton}
              handlerOpenAndCloseDialogAlert={handlerOpenAndCloseDialogAlert}
              requiredTote={requiredTote}
              statePositionsScaned={statePositionsScaned}
              setStatePositionsScaned={setStatePositionsScaned}
              configPickingRoutePositionScan={configPositionScan}
            />
          )}
          {step === EnumPickingStep.ViewPickingProductDiff && (
            <PickingProductDiff
              pickingRoute={pickingRoute}
              pickingRouteDetails={pickingRouteDetails}
              handlePickUp={handleProductPickUp}
              handleSkip={handleProductSkip}
              handleOutOfStock={handleProductOutOfStock}
              configPickingRoutePositionScan={configPositionScan}
            />
          )}
          {step === EnumPickingStep.ViewNoRoute && (
            <PickingNoRoute handleStartPicking={handleBeginProcess} />
          )}
          {step === EnumPickingStep.ViewNoProduct && (
            <PickingNoProduct
              pickingRoute={pickingRoute}
              handleEmptying={handleSetStateEmptying}
            />
          )}
          {step === EnumPickingStep.ViewPickingFinished && (
            <PickingFinished
              pickingRoute={pickingRoute}
              handleFinishRoute={handleFinishRoute}
              handleLPNButton={handleLPNButton}
              requiredTote={requiredTote}
            />
          )}
          {step === EnumPickingStep.ViewPickingMessage && (
            <PickingMessage
              messageView={messageView}
              handleErrorReturn={handleErrorReturn}
            />
          )}
          {step === EnumPickingStep.ViewPickingRouteDetails && (
            <PickingRouteReview
              pickingRoute={pickingRoute}
              reviewType={PickingRouteDetailsReviewType.AllProductDetails}
            />
          )}
          {step === EnumPickingStep.ViewPickingRouteDetailsProgress && (
            <PickingRouteReview
              pickingRoute={pickingRoute}
              reviewType={PickingRouteDetailsReviewType.InProgressDetails}
            />
          )}
          {step === EnumPickingStep.ModifyLPN && pickingRoute && (
            <ModifyLPNStep
              goBack={() => setStep(previousStep)}
              pickingRoute={pickingRoute}
              updatePickingRoute={setPickingRoute}
            />
          )}
        </Paper>
      </Container>

      <Modal
        open={isOpen}
        title={title}
        onClose={closeModalDialog}
        maxWidth={size}
      >
        <Typography variant='body1' style={{ color: 'red' }}>
          {messageDialogAlert}
        </Typography>
      </Modal>

      <Modal
        open={isOpenModalRTV}
        maxWidth={sizeModalRTV}
        onClose={closeModalRTV}
        cancelButton={{
          title: 'Salir',
          action: closeModalRTV
        }}
        successButton={{
          title: 'Aceptar',
          action: handleRtvGenerateRoute
        }}
      >
        <Typography variant='body1' style={{ color: 'black' }}>
          {'¿Desea Pickear Ordenes De Trabajo De RTV?'}
        </Typography>
      </Modal>

      <Modal
        open={isOpenModalRecall}
        maxWidth={sizeModalRecall}
        onClose={closeModalRecall}
        cancelButton={{
          title: 'Salir',
          action: closeModalRecall
        }}
        successButton={{
          title: 'Aceptar',
          action: handleRecallGenerateRoute
        }}
      >
        <Typography variant='body1' style={{ color: 'black' }}>
          {'¿Desea Pickear Ordenes De Trabajo De Recall?'}
        </Typography>
      </Modal>
    </PickingRouteContext.Provider>
  )
}
